import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../Actions/services";
// import { setMessage } from "./message";
// const user = JSON.parse(localStorage.getItem("user"));

export const getQualifications = createAsyncThunk(
  "qualifications",
  async ({ page, perPage }, thunkAPI) => {
    try {
      const data = await userService.getUserQualifications(page, perPage);

      return { qualifications: data.data, totalPages: data.headers["x-wp-totalpages"] };
    } catch (error) {
      //   const message =
      //     (error.response &&
      //       error.response.data &&
      //       error.response.data.message) ||
      //     error.message ||
      //     error.toString();
      //     console.log(message)
      //   thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  qualifications: [],
  totalPages: 0,
};

const getQualificationsSlice = createSlice({
  name: "qualifications",
  initialState,
  extraReducers: {
    // [getQualifications.fulfilled]: (state, action) => {
    //   return (state = [...action.payload.qualifications, { totalPages: action.payload.totalPages }]);
    // },
    [getQualifications.fulfilled]: (state, action) => {
      state.qualifications = action.payload.qualifications;
      state.totalPages = action.payload.totalPages;
    },
    [getQualifications.rejected]: (state, action) => {
      return (state = []);
    },
  },
});
const { reducer } = getQualificationsSlice;
export default reducer;
